module.exports = __webpack_public_path__ + "files/2c56f65d58499028482393f9732ee9f7.png";